import PropTypes from 'prop-types';
import { useMemo } from 'react';
import CheckboxSelectFilter from '../../../../Filters/CheckboxSelectFilter';
import buildTourFilterOptions from '../../../../../helpers/buildTourFilterOptions';
import useTourFilter from '../../../../../hooks/useTourFilter';

const TourTypeFilter = ({ tripId, variant, filterSpacingClass }) => {
  const { searchObj, filters, applyFilter } = useTourFilter(tripId);

  const options = useMemo(
    () => buildTourFilterOptions(filters?.types, searchObj.types),
    [filters, searchObj.types],
  );

  if (options.length === 0) {
    return <></>;
  }

  return (
    <CheckboxSelectFilter
      label="Tour type"
      options={options}
      values={searchObj.types || []}
      onChange={(types) => applyFilter({ types })}
      variant={variant}
      filterSpacingClass={filterSpacingClass}
      filterMaxWidthClass="max-w-full"
      menuWidthClass="w-full md:w-max"
    />
  );
};

TourTypeFilter.propTypes = {
  tripId: PropTypes.string,
  variant: PropTypes.string,
  filterSpacingClass: PropTypes.string,
};

TourTypeFilter.defaultProps = {
  tripId: undefined,
  variant: 'outline',
  filterSpacingClass: undefined,
};

export default TourTypeFilter;
